import postAPI from './postAPI.js'

export default async function postSendTaskMessage(body) {
    const data = await postAPI('taskmessages/send', body);
    return data;
}
